import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../config/app-config';
import { ApiClientError, ApiEnvelope } from '../../models/api/api-envelope';
import { Location } from '../../models/api/location';
import { buildApiUrl } from '../api-http/form-url-encoded';

@Injectable()
export class PosLocationsProvider {
  constructor(private http: HttpClient) {}

  load(apiKey: string): Promise<Location[]> {
    if (!apiKey) { return Promise.reject(new ApiClientError('api', 'La sesión ya no está disponible.')); }
    return this.http.get<ApiEnvelope<any[]>>(
      buildApiUrl(APP_CONFIG.apiBaseUrl, 'catalogo-local/admin-locaciones'),
      { headers: new HttpHeaders({ Authorization: apiKey }) }
    ).toPromise().then(function (response) {
      if (!response || String(response.code) !== '0' || !Array.isArray(response.data)) {
        throw new ApiClientError('locations', response && response.message || 'No fue posible obtener las locaciones de punto de venta.');
      }
      const locations = response.data.filter(function (location) {
        return location && (typeof location.idlocacion === 'number' || typeof location.idlocacion === 'string') &&
          typeof location.nombre === 'string' && location.nombre.length > 0 && Number(location.puntoventa) === 1;
      }).map(function (location) {
        return { idlocacion: location.idlocacion, nombre: location.nombre, activo: '' } as Location;
      });
      if (locations.length === 0) {
        throw new ApiClientError('empty', 'No hay locaciones de punto de venta autorizadas.');
      }
      return locations;
    }).catch(function (error) {
      if (error instanceof ApiClientError) { return Promise.reject(error); }
      return Promise.reject(new ApiClientError('network', 'No fue posible obtener las locaciones de punto de venta.'));
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/pos-locations/pos-locations.ts